import { render, staticRenderFns } from "./InformacoesPromocaoPeriodos.vue?vue&type=template&id=0394dd52&scoped=true&"
import script from "./InformacoesPromocaoPeriodos.vue?vue&type=script&lang=js&"
export * from "./InformacoesPromocaoPeriodos.vue?vue&type=script&lang=js&"
import style0 from "./InformacoesPromocaoPeriodos.vue?vue&type=style&index=0&id=0394dd52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0394dd52",
  null
  
)

export default component.exports